/* Lightweight Hebrew cookie-consent banner (2026-09-30), wired to Shopify Customer Privacy API.
   - Defers to Shopify's own banner when Shopify decides to show it (shouldShowBanner) to avoid duplicates.
   - Records the visitor's choice with Shopify.customerPrivacy.setTrackingConsent. */
(function(){
  'use strict';
  var C=window.SiteConsentConfig||{}; if(C.enabled===false) return;
  var KEY='site_consent_v1';
  function stored(){try{return localStorage.getItem(KEY)}catch(e){return null}}
  function remember(v){try{localStorage.setItem(KEY,v)}catch(e){}}
  var forced=/[?&]site_consent_test=1/.test(location.search);
  if(stored()&&!forced) return;
  function withApi(cb){
    if(window.Shopify&&Shopify.customerPrivacy&&Shopify.customerPrivacy.setTrackingConsent) return cb(Shopify.customerPrivacy);
    if(window.Shopify&&Shopify.loadFeatures){
      Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(err){cb(err?null:(Shopify.customerPrivacy||null))});
    } else cb(null);
  }
  function setConsent(api,o){
    if(!api) return;
    try{api.setTrackingConsent({analytics:o.analytics,marketing:o.marketing,preferences:o.preferences,sale_of_data:o.marketing},function(){})}catch(e){}
  }
  function build(api){
    var w=document.createElement('div'); w.id='site-consent'; w.setAttribute('dir','rtl');
    w.setAttribute('role','region'); w.setAttribute('aria-label',C.title||'הסכמה לשימוש בעוגיות');
    var priv=C.privacyUrl?' <a href="'+C.privacyUrl+'">'+(C.privacyLabel||'מדיניות הפרטיות')+'</a>':'';
    w.innerHTML='<div class="site-consent__box">'+
      '<div class="site-consent__txt"><h2>'+(C.title||'')+'</h2><p>'+(C.text||'')+priv+'</p>'+
        '<div class="site-consent__prefs" hidden><label><input type="checkbox" checked disabled> <span>הכרחיות (תמיד פעילות)</span></label>'+
        '<label><input type="checkbox" data-c="analytics"> <span>סטטיסטיקה וניתוח שימוש</span></label>'+
        '<label><input type="checkbox" data-c="marketing"> <span>שיווק ופרסום מותאם</span></label>'+
        '<label><input type="checkbox" data-c="preferences"> <span>העדפות</span></label></div></div>'+
      '<div class="site-consent__actions">'+
        '<button type="button" class="site-consent__accept">'+(C.accept||'אני מסכים')+'</button>'+
        '<button type="button" class="site-consent__decline">'+(C.decline||'לא מסכים')+'</button>'+
        '<button type="button" class="site-consent__more" aria-expanded="false">'+(C.prefs||'הגדרות')+'</button>'+
        '<button type="button" class="site-consent__save" hidden>'+(C.save||'שמירת בחירה')+'</button>'+
      '</div></div>';
    document.body.appendChild(w);
    document.documentElement.classList.add('site-consent-open');
    var setH=function(){document.documentElement.style.setProperty('--sa-consent-h',(w.firstChild.offsetHeight+12)+'px')};setH();window.addEventListener('resize',setH);
    function done(o,label){setConsent(api,o);remember(label);w.remove();document.documentElement.style.removeProperty('--sa-consent-h');document.documentElement.classList.remove('site-consent-open')}
    w.querySelector('.site-consent__accept').onclick=function(){done({analytics:true,marketing:true,preferences:true},'all')};
    w.querySelector('.site-consent__decline').onclick=function(){done({analytics:false,marketing:false,preferences:false},'none')};
    var more=w.querySelector('.site-consent__more'),prefs=w.querySelector('.site-consent__prefs'),sv=w.querySelector('.site-consent__save');
    more.onclick=function(){var o=prefs.hidden;prefs.hidden=!o;sv.hidden=!o;more.setAttribute('aria-expanded',o?'true':'false');setH()};
    sv.onclick=function(){var o={};w.querySelectorAll('[data-c]').forEach(function(i){o[i.getAttribute('data-c')]=i.checked});done(o,'custom')};
  }
  function start(){
    withApi(function(api){
      try{ if(!forced&&api){ if(api.shouldShowBanner&&api.shouldShowBanner()) return; var v=api.currentVisitorConsent&&api.currentVisitorConsent(); if(v&&(v.marketing||v.analytics||v.preferences)) return; } }catch(e){}
      build(api);
    });
  }
  if(document.readyState==='complete') setTimeout(start,600); else window.addEventListener('load',function(){setTimeout(start,600)});
})();
